import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-privacystatementFR',
  templateUrl: '../../../assets/html/privacystatementFR.html',
  styleUrls: ['./privacystatementFR.component.css']
})
export class PrivacystatementFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
